import { Injectable, Output, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MatBottomSheet } from '@angular/material';
import { Router } from '@angular/router';
import { MobileComponent } from '../pages/checkout-process/mobile/mobile.component';
import { LoginService } from './checkout-services/login.service';
import { SessionInfo } from '../models/User';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();
  path = '/login';
  user = 'Login';

  constructor(
    private cookie: CookieService,
    private _bottomSheet: MatBottomSheet,
    private loginService: LoginService,
    private router: Router
  ) {}

  getSession(): SessionInfo | null {
    const Authorization = this.cookie.get('Authorization');
    const userId = this.cookie.get('UserID');

    if (!Authorization || !userId) {
      return null;
    }

    return { Authorization, userId };
  }

  canActivate(): boolean {
    const session = this.getSession();

    if (session) {
      this.loginService.get(session).subscribe({
        next: (res) => {
          this.user = res.body.firstName;
          this.getLoggedInName.emit(this.user);
        },
        error: (err) => {
          console.error('Failed to fetch user', err);
        }
      });
    }

    if (window.innerWidth < 768) {
      if (!session) {
        this.router.navigate(['home']);
        this._bottomSheet.open(MobileComponent);
        return false;
      }
    } else {
      if (!session) {
        this.router.navigate(['login']);
        return false;
      }
    }

    return true;
  }
}
